import { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs'
import { createBotUser } from '../../../../API/Users/Users'
import toast from 'react-hot-toast'

interface Props {
    show: boolean
    onHide: () => void
}

export const CreateUserModal = ({ show, onHide }: Props) => {
    const [showPassword, setShowPassword] = useState(false)
    const [formData, setFormData] = useState({
        name: '',
        password: ''
    })

    const handleSave = async () => {
        const user = {
            name: formData.name,
            password: formData.password
        }

        if (user.name === '' || user.password === '') {
            toast.error('Nombre y contraseña son requeridos')
            return
        }

        if (user.password.length < 6) {
            toast.error('La contraseña debe tener al menos 6 caracteres')
            return
        }

        try {
            let result = await createBotUser(user)
            if (result?.id) {
                toast.success(`Usuario ${user.name} creado correctamente`)
                onHide()
            } else {
                const errorMessage = result?.response?.data?.msg ?? 'Error al crear el usuario'
                toast.error(errorMessage)
            }
        } catch (error) {
            toast.error(`Error al crear el usuario ${user.name}`)
            console.log(error)
        }
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Crear Usuario</Modal.Title>
            </Modal.Header>


            <Modal.Body className='d-flex flex-column p-3'>

                <div className='d-flex justify-content-center flex-column gap-1'>
                    <label className='form-label'>Nombre</label>
                    <input type="text" className='form-control' value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
                </div>
                <div className='d-flex justify-content-center flex-column gap-1'>
                    <label className='form-label'>Contraseña</label>
                    <div className='position-relative'>

                        <input type={showPassword ? 'text' : 'password'} className='form-control' value={formData.password} onChange={(e) => setFormData({ ...formData, password: e.target.value })} />
                        <div onClick={() => setShowPassword(!showPassword)} className='cursor-pointer position-absolute' role='button' style={{ right: '10px', top: '40%', transform: 'translateY(-50%)' }} >
                            {showPassword ? <BsEyeSlashFill size={20} /> : <BsEyeFill size={20} />}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className='d-flex justify-content-center'>
                    <Button variant="primary" onClick={handleSave}>
                        Guardar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}
